import { Action } from '@reduxjs/toolkit'

import {
  ADD_CATALOG_APP_INSTANCE_SUCCESS,
  CLEAR_CURRENT_APP_INSTANCE,
  CLEAR_CURRENT_CATALOG_APP,
  DELETE_CATALOG_APP_INSTANCE_SUCCESS,
  FETCH_CATALOG_APP_INSTANCE_SUCCESS,
  FETCH_CATALOG_APP_SUCCESS,
  UPDATE_CATALOG_APP_INSTANCE_SUCCESS
} from './actionTypes'
import { CatalogAppDetails, CatalogAppInstance } from './interfaces'

interface CatalogAppAction extends Action {
  response: CatalogAppDetails
}

interface CatalogAppInstanceAction extends Action {
  response: CatalogAppInstance
}

interface SpaceCatalogAppDetailsPageState {
  app?: CatalogAppDetails
  appInstance: CatalogAppInstance
  isLoading?: boolean
  isInstallSuccessful?: boolean
}

const initialState: SpaceCatalogAppDetailsPageState = { appInstance: {} as CatalogAppInstance }

export default (
  state = initialState,
  action: CatalogAppAction | CatalogAppInstanceAction
): SpaceCatalogAppDetailsPageState => {
  switch (action.type) {
    case FETCH_CATALOG_APP_SUCCESS: {
      action = action as CatalogAppAction

      return {
        ...state,
        app: action.response
      }
    }
    case CLEAR_CURRENT_CATALOG_APP: {
      return {
        ...state,
        app: undefined
      }
    }
    case FETCH_CATALOG_APP_INSTANCE_SUCCESS: {
      action = action as CatalogAppInstanceAction

      return {
        ...state,
        appInstance: action.response
      }
    }
    case ADD_CATALOG_APP_INSTANCE_SUCCESS: {
      action = action as CatalogAppInstanceAction

      return {
        ...state,
        appInstance: action.response
      }
    }
    case UPDATE_CATALOG_APP_INSTANCE_SUCCESS: {
      action = action as CatalogAppInstanceAction

      return {
        ...state,
        appInstance: action.response
      }
    }
    case DELETE_CATALOG_APP_INSTANCE_SUCCESS: {
      return {
        ...state,
        ...action.response
      }
    }
    case CLEAR_CURRENT_APP_INSTANCE: {
      return {
        ...state,
        ...initialState
      }
    }
    default: {
      return state
    }
  }
}
